import React, { useEffect, useState } from "react";
import { Card, Button, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import TrainingIntro from "../TrainingIntro";
import TasksTables from "./TasksTables";
import PendingReportsCard from "./PendingReportsCard";
import SubmitReportModal from "./SubmitReportModal";
import helper from "../tableColumns";
import { useTrainingDetail } from "PlatForms/OrgLMS/Hooks/LearnerHooks/useTrainingDetail";
import usePendingReports from "./usePendingReports";
import ReportIssuesCard from "./ReportIssues";
const TrainingOverview = () => {
  const location = useLocation();
  const { trainingId, ownMemberId } = location.state || {};
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { pendingReports, pendingCount, fetchPendingReports } = usePendingReports(
    trainingId,
    token,
    ownMemberId
  );
  const {
    groupMemberId,
    setGroupMemberId,
    form,
    projectData,
    loading,
    fetchProjects,
    formVisible,
    submitting,
    catLoading,
    handleCategoryChange,
    handleCategorySubmit,
    categories,
    setFormVisible,
    questions,
  } = useTrainingDetail(trainingId);
  const { taskColumns, inProgressColumns, SubmitModal, ViewModal, inProgressTasks, pendingTasks } =
    helper(trainingId, fetchPendingReports);
  const memberId = ownMemberId;
  const alertCount = projectData?.issueAlertCount;
  useEffect(() => {
    fetchProjects();
    fetchPendingReports();
  }, [trainingId]);
  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/TrainingProgressReport/Submit`,
        {
          taskId: values.taskId,
          memberId: ownMemberId,
          reportText: values.reportText,
        },
        {
          headers: {
            accept: "*/*",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      message.success("Report submitted successfully!");
      setIsModalVisible(false);
      form.resetFields();
      fetchPendingReports();
    } catch (error) {
      console.error("Error submitting report:", error);
      message.error("Failed to submit report");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <Card
      loading={loading}
      className="card-professional"
      title="Training Overview"
      variant="borderless"
      extra={<Button onClick={() => navigate(-1)}>Back</Button>}
    >
      <TrainingIntro
        projectData={projectData}
        groupMemberId={groupMemberId}
        setGroupMemberId={setGroupMemberId}
        fetchProjects={fetchProjects}
      />
      <hr />
      <TasksTables
        pendingTasks={pendingTasks}
        inProgressTasks={inProgressTasks}
        taskColumns={taskColumns}
        inProgressColumns={inProgressColumns}
      />
      <PendingReportsCard pendingCount={pendingCount} onShowModal={() => setIsModalVisible(true)} />
      <SubmitReportModal
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        onFinish={handleSubmit}
        isSubmitting={isSubmitting}
        form={form}
        pendingReports={pendingReports}
      />
      <ReportIssuesCard
        form={form}
        formVisible={formVisible}
        setFormVisible={setFormVisible}
        categories={categories}
        questions={questions}
        handleCategoryChange={handleCategoryChange}
        handleCategorySubmit={handleCategorySubmit}
        submitting={submitting}
        catLoading={catLoading}
        alertCount={alertCount}
        memberId={memberId}
      />
      {SubmitModal}
      {ViewModal}
    </Card>
  );
};
export default TrainingOverview;
